export const currencyLocaleOverride: Record<string, string> = {
  PLN: 'pl-PL',
  EUR: 'en-IE',
  USD: 'en-US',
  GBP: 'en-GB',
  CZK: 'cs-CZ',
  SKK: 'sk-SK',
};

export function formatPrice(
  value: number | string,
  currency: string,
  locale?: string
): string {
  const numberValue =
    typeof value === 'string' ? Number(value.replace(',', '.')) : value;

  if (!Number.isFinite(numberValue)) {
    return `${value} ${currency ?? ''}`;
  }

  const loc = locale || currencyLocaleOverride[currency];

  try {
    return numberValue.toLocaleString(loc, {
      style: 'currency',
      currency,
      currencyDisplay: 'code',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    });
  } catch {
    return `${numberValue.toFixed(2)} ${currency ?? ''}`;
  }
}
